import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import Table, { ExpandedRow, ExpandableRow } from '../../components/ExpandableTable';
import moment from 'moment';

import actions from './actions';

class ListaConsumo extends Component {
  componentDidMount () {
    this.props.actions.onLoadConsumoAguaMineralPorCompetencia();
  }

  dateFormat (value) {
    return !!value && moment(value).format("DD/MM/YYYY HH:mm");
  }

  render() {
    const { value: { result } } = this.props;

    return !!result.length && (
      <Table async hover responsive size="sm">
        <thead>
          <tr>
            <th>Competência</th>
            <th className="text-right">Solicitado</th>
            <th className="text-right">Entregue</th>
          </tr>
        </thead>
        {result.map((v, i) => (
          <ExpandableRow key={i} onExpand={expanded => {
            if (expanded) {
              return this.props.actions.onLoadConsumoAguaMineralDetalhePorCompetencia(v);
            }
            return Promise.resolve();
          }}>
            <td>{moment(v.competencia).format('MM/YYYY')}</td>
            <td className="text-right">{v.total_solicitado}</td>
            <td className="text-right">{v.total_entregue}</td>
            <ExpandedRow>
              {v.detail && <Table>
                <thead>
                  <tr>
                    <th>Unidade</th>
                    <th>Produto</th>
                    <th className="text-right">Solicitado</th>
                    <th className="text-right">Entregue</th>
                  </tr>
                </thead>
                <tbody>
                  {v.detail.result.map((detail, i) => (<tr key={i}>
                    <td>{detail.unidade}</td>
                    <td>{detail.produto}</td>
                    <td className="text-right">{detail.total_solicitado}</td>
                    <td className="text-right">{detail.total_entregue}</td>
                  </tr>))}
                </tbody>
              </Table>}
            </ExpandedRow>
          </ExpandableRow>
        ))}
      </Table>
    );
  }
}

let mapStateToProps = ({ consumo:{ competencias } }) => ({
  value: competencias
});

let mapDispatchToProps = dispatch => ({
  actions: bindActionCreators(actions, dispatch)
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ListaConsumo);



// WEBPACK FOOTER //
// ./src/modules/aguaMineral/ListaSolicitacoesPorCompetencia.js